// extracted by mini-css-extract-plugin
export default {"form":"DataForm_form__vZ66W","overlay":"DataForm_overlay__ZFCNS"};